import { Component } from '@angular/core';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import {
  DAIRYNEXT_REPORT_IDS,
  DAIRYNEXT_WORKSPACE_ID,
  SINGLE_PAGE_POWERBI_CONFIG,
} from 'src/app/shared/models/powerbi-config.model';

@Component({
  selector: 'app-sustainability',
  templateUrl: './sustainability.component.html',
  imports: [PowerbiReportComponent],
})
export class SustainabilityComponent {
  public readonly workspaceId = DAIRYNEXT_WORKSPACE_ID;
  public readonly reportId = DAIRYNEXT_REPORT_IDS.SUSTAINABILTY;
  public readonly baseEmbedConfig = SINGLE_PAGE_POWERBI_CONFIG;
}
